export const scanLogsApi = {
  scanLogs: {
    queryKey: (params?: Record<string | number, string | number>) => [
      "scan-logs",
      ...(params ? Object.entries(params).flat() : []),
    ],
    route: (params?: Record<string | number, string | number> | undefined) => {
      const qs = params
        ? "?" +
          new URLSearchParams(
            Object.entries(params).map(([k, v]) => [k, String(v)]),
          ).toString()
        : "";
      return `participant-scan-logs${qs}`;
    },
    exportRoute: (params?: Record<string | number, string | number>) => {
      const qs = params
        ? "?" +
          new URLSearchParams(
            Object.entries(params).map(([k, v]) => [k, String(v)]),
          ).toString()
        : "";
      return `participant-scan-logs/export${qs}`;
    },
  },
};
